import stateDialog from './stateDialog.vue'
const state_dialog = {
    install: function (Vue) {
        Vue.component('state_dialog', stateDialog)
    }
};
// 导出组件
export default state_dialog